var saarlandQuestions = [
  {
    id: '301',
    question: 'Welches Wappen gehört zum Bundesland Saarland?',
    image: '411',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 1,
      },
    ],
    category: 'Saarland',
  },
  {
    id: '302',
    question: 'Welches ist ein Landkreis im Saarland?',
    answers: [
      {
        content: 'Demmin',
        key: 0,
      },
      {
        content: 'Altötting',
        key: 0,
      },
      {
        content: 'Neunkirchen',
        key: 1,
      },
      {
        content: 'Rhein-Sieg-Kreis',
        key: 0,
      },
    ],
    category: 'Saarland',
  },
  {
    id: '303',
    question: 'Für wie viele Jahre wird der Landtag des Saarlandes gewählt?',
    answers: [
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
      {
        content: '5',
        key: 1,
      },
      {
        content: '6',
        key: 0,
      },
    ],
    category: 'Saarland',
  },
  {
    id: '304',
    question: 'Ab welchem Alter darf man im Saarland bei Kommunalwahlen wählen?',
    answers: [
      {
        content: '14',
        key: 0,
      },
      {
        content: '16',
        key: 0,
      },
      {
        content: '18',
        key: 1,
      },
      {
        content: '20',
        key: 0,
      },
    ],
    category: 'Saarland',
  },
  {
    id: '305',
    question: 'Welche Farben hat die Landesflagge des Saarlandes?',
    answers: [
      {
        content: 'weiß-blau',
        key: 0,
      },
      {
        content: 'schwarz-rot-gold',
        key: 1,
      },
      {
        content: 'schwarz-gelb',
        key: 0,
      },
      {
        content: 'grün-weiß-rot',
        key: 0,
      },
    ],
    category: 'Saarland',
  },
  {
    id: '306',
    question: 'Wo können Sie sich im Saarland über politische Themen informieren?',
    answers: [
      {
        content: 'bei den Kirchen',
        key: 0,
      },
      {
        content: 'bei der Landeszentrale für politische Bildung',
        key: 1,
      },
      {
        content: 'bei der Verbraucherzentrale',
        key: 0,
      },
      {
        content: 'beim Ordnungsamt der Gemeinde',
        key: 0,
      },
    ],
    category: 'Saarland',
  },
  {
    id: '307',
    question: 'Die Landeshauptstadt des Saarlandes heißt...',
    answers: [
      {
        content: 'Neunkirchen.',
        key: 0,
      },
      {
        content: 'Homburg.',
        key: 0,
      },
      {
        content: 'Saarbrücken.',
        key: 1,
      },
      {
        content: 'Völklingen.',
        key: 0,
      },
    ],
    category: 'Saarland',
  },
  {
    id: '308',
    question: 'Welches Bundesland ist das Saarland?',
    image: '418',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 1,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Saarland',
  },
  {
    id: '309',
    question: 'Wie nennt man den Regierungschef / die Regierungschefin des Saarlandes?',
    answers: [
      {
        content: 'Erster Minister / Erste Ministerin',
        key: 0,
      },
      {
        content: 'Premierminister / Premierministerin',
        key: 0,
      },
      {
        content: 'Bürgermeister / Bürgermeisterin',
        key: 0,
      },
      {
        content: 'Ministerpräsident / Ministerpräsidentin',
        key: 1,
      },
    ],
    category: 'Saarland',
  },
  {
    id: '310',
    question: 'Welchen Minister / welche Ministerin hat das Saarland nicht?',
    answers: [
      {
        content: 'Justizminister / Justizministerin',
        key: 0,
      },
      {
        content: 'Außenminister / Außenministerin',
        key: 1,
      },
      {
        content: 'Finanzminister / Finanzministerin',
        key: 0,
      },
      {
        content: 'Innenminister / Innenministerin',
        key: 0,
      },
    ],
    category: 'Saarland',
  },
]

export default saarlandQuestions
